import type { ReactNode } from 'react';

export const symbol_museum: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-80v-60h83v-411h-54q-12.35 0-20.68-9Q80-569 80-581q0-8.31 3.67-15.23Q87.33-603.15 94-608l351-248q8-5 16.81-8 8.81-3 18-3t18.19 3q9 3 17 8l351 248q6.67 4.9 10.33 12.25Q880-588.4 880-580q0 12.35-8.32 20.68Q863.35-551 851-551h-53v411h82v60H80Zm658-60v-485L480-806 223-625v485h515ZM494-307q6-3 11-10l72-108v154q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-217q0-11.45-7.77-19.23Q621.45-515 610-515h-23.4q-6.46 0-12.51 3.2T564-503l-84 128-83-126q-5-7-11.75-10.5T371-515h-15.14q-13.54 0-22.7 9.2T324-483v212q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-154l71 107q5 7 11 10.5t14 3.5q8 0 14-3Zm244 167H223h515Z"
		/>
	</svg>
);
